import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Homepage from "pages/homepage";
import OwnerPortal from "pages/owner-portal";
import PropertySearchDiscovery from "pages/property-search-discovery";
import PropertyDetailPage from "pages/property-detail-page";
import NeighborhoodIntelligenceHub from "pages/neighborhood-intelligence-hub";
import UserDashboard from "pages/user-dashboard";
import NotFound from "pages/NotFound";
import LoginPage from "pages/login";
import { AuthProvider, RequireAuth } from "utils/AuthContext";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/owner-portal" element={
            <RequireAuth fallback={<LoginPage />}> 
              <OwnerPortal />
            </RequireAuth>
          } />
          <Route path="/property-search-discovery" element={<PropertySearchDiscovery />} />
          <Route path="/property-detail-page" element={<PropertyDetailPage />} />
          {/* <Route path="/neighborhood-intelligence-hub" element={<NeighborhoodIntelligenceHub />} /> */}
          {/* <Route path="/user-dashboard" element={<UserDashboard />} />  */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;